export const ComplianceAbi = [
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "dapp",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "fullHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "partialHash",
				"type": "bytes32"
			}
		],
		"name": "ApprovalRequired",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "dapp",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "fullHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "complianceDetails",
				"type": "string"
			}
		],
		"name": "ComplianceConsumed",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "dapp",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "fullHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "complianceDetails",
				"type": "string"
			}
		],
		"name": "ComplianceRegistered",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "dapp",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "fullHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bool",
				"name": "approved",
				"type": "bool"
			}
		],
		"name": "ComplianceVerdict",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "chainid",
				"type": "uint256"
			},
			{
				"internalType": "bytes4",
				"name": "functionSelector",
				"type": "bytes4"
			},
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "computeErc20TransferPartialHash",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "partialHash",
				"type": "bytes32"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "chainid",
				"type": "uint256"
			},
			{
				"internalType": "bytes4",
				"name": "functionSelector",
				"type": "bytes4"
			},
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			},
			{
				"internalType": "bytes",
				"name": "data",
				"type": "bytes"
			}
		],
		"name": "computeErc20TransferWithDataPartialHash",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "partialHash",
				"type": "bytes32"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "chainid",
				"type": "uint256"
			},
			{
				"internalType": "bytes4",
				"name": "functionSelector",
				"type": "bytes4"
			},
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "computeEthTransferPartialHash",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "partialHash",
				"type": "bytes32"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "chainid",
				"type": "uint256"
			},
			{
				"internalType": "bytes4",
				"name": "functionSelector",
				"type": "bytes4"
			},
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			},
			{
				"internalType": "bytes",
				"name": "data",
				"type": "bytes"
			}
		],
		"name": "computeEthTransferWithDataPartialHash",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "partialHash",
				"type": "bytes32"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "chainid",
				"type": "uint256"
			},
			{
				"internalType": "bytes4",
				"name": "functionSelector",
				"type": "bytes4"
			},
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			},
			{
				"internalType": "bytes",
				"name": "data",
				"type": "bytes"
			}
		],
		"name": "computeGenericCallPartialHash",
		"outputs": [
			{
				"internalType": "bytes32",
				"name": "partialHash",
				"type": "bytes32"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "dapp",
				"type": "address"
			},
			{
				"internalType": "bytes32",
				"name": "partialHash",
				"type": "bytes32"
			}
		],
		"name": "getStatus",
		"outputs": [
			{
				"internalType": "enum IComplianceOracle.Status",
				"name": "",
				"type": "uint8"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "dapp",
				"type": "address"
			},
			{
				"internalType": "bytes32",
				"name": "partialHash",
				"type": "bytes32"
			},
			{
				"internalType": "bool",
				"name": "approved",
				"type": "bool"
			}
		],
		"name": "issueVerdict",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
];

export default ComplianceAbi;
